import { getPathArray } from "@/utilities";

export const getSettingsPageName = (path: string) => {
  const pathArray = getPathArray(path);
  return pathArray[1] ? pathArray[1] : path;
};

export const getSettingsPageNameFromPath = () => {
  return getSettingsPageName(window.location.pathname);
};
